<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
    x="0px"
    y="0px"
    width="50.8px"
    height="50.8px"
    viewBox="0 0 50.8 50.8"
    style="enable-background:new 0 0 50.8 50.8;"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M25.4,0C11.4,0,0,11.4,0,25.4s11.4,25.4,25.4,25.4s25.4-11.4,25.4-25.4S39.4,0,25.4,0z M25.4,49.1
                            c-13,0-23.7-10.6-23.7-23.7S12.4,1.8,25.4,1.8s23.7,10.6,23.7,23.7S38.5,49.1,25.4,49.1z"
    />
    <rect x="14.3" y="23.2" class="st0" width="5" height="9.9" />
    <rect x="22.9" y="18.2" class="st0" width="5" height="15" />
    <rect x="31.6" y="12.9" class="st0" width="5" height="20.3" />
    <rect x="11.7" y="35.3" class="st0" width="27.5" height="1.8" />
  </svg>
</template>

<script>
export default {};
</script>
